export const PCB_CORE_URL = "https://api.eviacore.com";

